import axios from 'axios'
import WebInstance from '../utils/AxiosInstance'

const getAddress = async (lat: number, lng: number) => {
    return axios.get(`https://geocode.maps.co/reverse?lat=${lat?.toString()}&lon=${lng?.toString()}`)
}

export default getAddress
